/**
 * Roles of Form Builder
 * @author Phat Tran
 */

export default {
	// global
	canEditFormConfigurations: true,

	// sections
	canAddSection: true,
	canEditSection: true,
	canDeleteSection: true,
	canReOrderingSection: true,

	// rows/tab
	canAddRow: true,
	canEditRow: true,
	canDeleteRow: true,
	canReOrderingRow: true,

	// controls
	canAddControl: true,
	canEditControl: true,
	canDeleteControl: true,
	canReOrderingControl: true,

	// control-inner
	canUpdateControlBasicDetail: true,
	canUpdateControlStyling: true,
	canUpdateControlValidation: true,
	canUpdateControlSpecialConfiguration: true,

}